import Activity from "./Activity";

class Event {
    _id;
    title;
    description;
    startDate;
    endDate;
    startTime
    endTime
    location;
    price;
    ticketsAvailableNumber;
    status;
    activities;

    constructor() {
        this._id = null;
        this.title = null;
        this.description = null;
        this.startDate = null;
        this.endDate = null;
        this.startTime = null;
        this.endTime = null;
        this.location = null;
        this.price = null;
        this.ticketsAvailableNumber = null;
    }

    static fromJSON(json) {
        let event = new Event();
        event._id = json.id;
        event.title = json.title;
        event.description = json.description;
        event.startDate = json.start_date_formatted;
        event.endDate = json.end_date_formatted;
        event.startTime = json.start_time + " (ingreso desde las 7:30 a.m.)." ?? "-";
        event.endTime = json.end_time ?? "-";
        event.location = json.location;
        event.price = json.price_formatted;
        event.ticketsAvailableNumber = json.tickets_available_number;
        event.status = json.status;
        event.activities = json.activities ? json.activities.map((act) => Activity.fromJSON(act)) : [];
        return event;
    }
}

export default Event;